import React, { useState } from 'react';
import { Instagram, Facebook, Linkedin, MapPin, Phone, Mail, MessageCircle, Loader2 } from 'lucide-react';
export function Footer() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleMiniSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate submission
    await new Promise(resolve => setTimeout(resolve, 1000));
    setIsSubmitting(false);
    (e.target as HTMLFormElement).reset();
    alert('¡Gracias! Mensaje enviado.');
  };
  const services = ['Meta Ads · Google Ads · TikTok Ads · YouTube Ads', 'Email · SMS · Retargeting Automatizado', 'Automatización con IA para Ventas 24/7', 'Funnels Quirúrgicos por Industria', 'Blindaje Digital & Anti-Ban', 'PR Digital & Posicionamiento en Medios', 'CRM & Data Tracking Avanzado', 'Video Marketing IA · SEO · Branding', 'Gestión de Reputación · Google Maps', 'Diseño Web · Landing Pages · CRO'];
  const resources = ['Blog de Estrategia', 'Casos de Éxito', 'Política de Privacidad', 'Términos y Condiciones'];
  return <footer className="bg-[#0A0A0A] border-t border-gold/20 pt-16 pb-8 px-4 font-sans relative z-20" data-id="element-102">
      <div className="max-w-7xl mx-auto" data-id="element-103">
        {/* Top 4 Columns */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-104">
          {/* Column 1: Brand */}
          <div className="flex flex-col" data-id="element-105">
            <img src="https://cdn.magicpatterns.com/uploads/78tFowd5v8UUqp2rVG7xAK/IMG_6635.jpg" alt="Doctor Ecommerce" className="h-12 w-auto object-contain mb-2" data-id="element-106" />
            <p className="text-gold italic font-medium mb-6" data-id="element-107">
              La cura para negocios estancados.
            </p>
            <p className="text-neutral-400 text-sm leading-relaxed mb-8" data-id="element-108">
              En Doctor Ecommerce no gestionamos redes, operamos sistemas de
              adquisición de alto rendimiento. Con sede estratégica en Tampa,
              Florida, servimos a dueños de negocios en todo Estados Unidos,
              transformando presupuestos publicitarios en máquinas de generación
              de llamadas y ventas diarias.
            </p>
            <div className="flex gap-4" data-id="element-109">
              <a href="#" className="text-gold hover:text-white transition-colors" data-id="element-110">
                <Instagram className="w-5 h-5" data-id="element-111" />
              </a>
              <a href="#" className="text-gold hover:text-white transition-colors" data-id="element-112">
                <Facebook className="w-5 h-5" data-id="element-113" />
              </a>
              <a href="#" className="text-gold hover:text-white transition-colors" data-id="element-114">
                <Linkedin className="w-5 h-5" data-id="element-115" />
              </a>
              {/* TikTok custom icon since it's not in standard lucide sometimes, using a placeholder or text if needed, but we'll use a generic icon or text if missing. Lucide has no tiktok by default in older versions, we'll use a simple svg or just omit if it causes issues. Let's use an SVG for TikTok to be safe. */}
              <a href="#" className="text-gold hover:text-white transition-colors" data-id="element-116">
                <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor" data-id="element-117">
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" data-id="element-118" />
                </svg>
              </a>
            </div>
          </div>

          {/* Column 2: Servicios */}
          <div data-id="element-119">
            <h4 className="text-gold font-bold mb-6" data-id="element-120">SERVICIOS</h4>
            <ul className="space-y-4" data-id="element-121">
              {services.map((service, idx) => <li key={idx} className="text-neutral-400 text-sm hover:text-white transition-colors cursor-pointer" data-id="element-122">
                  {service}
                </li>)}
            </ul>
          </div>

          {/* Column 3: Recursos */}
          <div data-id="element-123">
            <h4 className="text-gold font-bold mb-6" data-id="element-124">RECURSOS</h4>
            <ul className="space-y-4" data-id="element-125">
              {resources.map((resource, idx) => <li key={idx} className="text-neutral-400 text-sm hover:text-white transition-colors cursor-pointer flex items-center gap-2" data-id="element-126">
                  <span className="text-neutral-600 text-xs" data-id="element-127">v</span> {resource}
                </li>)}
            </ul>
          </div>

          {/* Column 4: Contacto */}
          <div data-id="element-128">
            <h4 className="text-gold font-bold mb-6" data-id="element-129">CONTACTO DIRECTO</h4>
            <ul className="space-y-4 mb-8" data-id="element-130">
              <li className="flex items-start gap-3 text-neutral-300 text-sm" data-id="element-131">
                <MapPin className="w-5 h-5 text-gold shrink-0" data-id="element-132" />
                <span data-id="element-133">1001 WATER ST, TAMPA FL 33602</span>
              </li>
              <li className="flex items-center gap-3 text-neutral-300 text-sm" data-id="element-134">
                <Phone className="w-5 h-5 text-gold shrink-0" data-id="element-135" />
                <a href="tel:4028720639" className="hover:text-gold transition-colors" data-id="element-136">
                  402-872-0639
                </a>
              </li>
              <li className="flex items-center gap-3 text-neutral-300 text-sm" data-id="element-137">
                <Mail className="w-5 h-5 text-gold shrink-0" data-id="element-138" />
                <a href="mailto:doctor.ecommerceus@gmail.com" className="hover:text-gold transition-colors" data-id="element-139">
                  doctor.ecommerceus@gmail.com
                </a>
              </li>
            </ul>

            <div className="flex flex-col gap-3" data-id="element-140">
              <a href="tel:4028720639" className="w-full bg-emerald hover:bg-emerald/90 text-white font-bold py-3 px-4 rounded flex items-center justify-center gap-2 transition-colors text-sm" data-id="element-141">
                <MessageCircle className="w-4 h-4" data-id="element-142" /> Habla con un Especialista
              </a>
              <a href="https://calendar.app.google/gDsqAVqmwUYm" target="_blank" rel="noopener noreferrer" className="w-full bg-[#D4A373] hover:bg-[#C39362] text-carbon font-bold py-3 px-4 rounded flex items-center justify-center gap-2 transition-colors text-sm" data-id="element-143">
                <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-144">
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2" data-id="element-145"></rect>
                  <line x1="16" y1="2" x2="16" y2="6" data-id="element-146"></line>
                  <line x1="8" y1="2" x2="8" y2="6" data-id="element-147"></line>
                  <line x1="3" y1="10" x2="21" y2="10" data-id="element-148"></line>
                </svg>
                RESERVAR DIAGNÓSTICO
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar: Partners & Mini Form */}
        <div className="border-t border-border pt-8 pb-12 flex flex-col lg:flex-row justify-between items-start lg:items-center gap-8" data-id="element-149">
          <div className="flex flex-col gap-4" data-id="element-150">
            <h5 className="text-neutral-500 text-xs font-bold tracking-widest uppercase" data-id="element-151">
              PARTNERS CERTIFICADOS Y TECNOLOGÍA DE ÉLITE
            </h5>
            <div className="flex flex-wrap gap-3" data-id="element-152">
              {/* Placeholder badges for partners */}
              <div className="bg-white px-4 py-2 rounded text-xs font-bold text-black" data-id="element-153">
                Meta Business Partner
              </div>
              <div className="bg-white px-4 py-2 rounded text-xs font-bold text-black" data-id="element-154">
                Google Ads
              </div>
              <div className="bg-white px-4 py-2 rounded text-xs font-bold text-black" data-id="element-155">
                Shopify Experts
              </div>
            </div>
          </div>

          <div className="w-full lg:w-auto" data-id="element-156">
            <h5 className="text-neutral-500 text-xs font-bold tracking-widest uppercase mb-4" data-id="element-157">
              ¿QUIERES QUE TE CONTACTEMOS?
            </h5>
            <form onSubmit={handleMiniSubmit} className="flex flex-col sm:flex-row gap-3" data-id="element-158">
              <input type="text" placeholder="Tu Nombre" required className="bg-transparent border border-border rounded px-4 py-2 text-sm text-white focus:border-gold focus:outline-none w-full sm:w-32" data-id="element-159" />
              <input type="email" placeholder="Tu Email" required className="bg-transparent border border-border rounded px-4 py-2 text-sm text-white focus:border-gold focus:outline-none w-full sm:w-32" data-id="element-160" />
              <input type="tel" placeholder="Tu Teléfono" required className="bg-transparent border border-border rounded px-4 py-2 text-sm text-white focus:border-gold focus:outline-none w-full sm:w-32" data-id="element-161" />
              <input type="text" placeholder="Nombre de tu Empresa" required className="bg-transparent border border-border rounded px-4 py-2 text-sm text-white focus:border-gold focus:outline-none w-full sm:w-40" data-id="element-162" />
              <button type="submit" disabled={isSubmitting} className="bg-[#D4A373] hover:bg-[#C39362] text-carbon font-bold px-6 py-2 rounded transition-colors text-sm disabled:opacity-70" data-id="element-163">
                {isSubmitting ? <Loader2 className="w-4 h-4 animate-spin mx-auto" data-id="element-164" /> : 'ENVIAR'}
              </button>
            </form>
          </div>
        </div>

        {/* Copyright */}
        <div className="text-center text-neutral-600 text-xs pt-8 border-t border-border/50" data-id="element-165">
          © 2026 Doctor Ecommerce. Todos los derechos reservados.
        </div>
      </div>
    </footer>;
}